'use strict';

var site = {

    init: function () {
        document.body.classList.remove('preload');
        site.plugins.init();
        site.signoutRedirect();
    },

    plugins: {

        init: function() {
	        site.plugins.tooltips();
        },

        tooltips: function () {
	        if (typeof tippy === 'undefined') return;
	        tippy('[data-tooltip]', {
		        content: function (ref) {
			        return ref.getAttribute('data-tooltip');
		        }
	        });
        }

    },

    signoutRedirect: function() {
        var link = document.querySelector('a.PostLogoutRedirectUri');
        if (link) {
            window.location = link.href;
        }
    }
};

window.addEventListener('load', site.init());